import { render, staticRenderFns } from "./pjnoticeIndex.vue?vue&type=template&id=789c2380"
import script from "./pjnoticeIndex.vue?vue&type=script&lang=js"
export * from "./pjnoticeIndex.vue?vue&type=script&lang=js"
import style0 from "./pjnoticeIndex.vue?vue&type=style&index=0&id=789c2380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports